enum Meal {
	NONE = 'NONE', BREAKFAST = 'BREAKFAST', HALF_BOARD = 'HALF_BOARD', FULL_BOARD = 'FULL_BOARD', ALL_INCLUSIVE = 'ALL_INCLUSIVE'
}

export default Meal;